<div>
  <div class="mb-3 message-card">
    @if (!isKitBenefit && !isKitBuyUpBenefit && !isFutureBenefit) {
    <span>
      <mwp-text-translate
        text="Please select from your currently available benefit(s) listed below. If a benefit has an “Unavailable On” date illustrated, you will be prompted to select a replacement benefit option on a subsequent page that is valid after this benefit expires. Click Confirm to continue."
        jsonKey="benefitSelectionNote" />
    </span>
    }
    @if (isKitBenefit) {
    <span>
      <mwp-text-translate text="Items listed below are optional additions to the base plan you have selected. If you wish to enroll in the options listed, check the box next to the options name and click continue." jsonKey="benefitSelectionKitBenefit" />
    </span>
    }
    @if (isKitBuyUpBenefit) {
    <span>
      <mwp-text-translate text="The item(s) listed below are additions to the base plan you have selected. If you wish to enroll in the option(s) listed, please check the box next to the option(s) name." jsonKey="benefitSelectionKitBuyUpBenefit" />
    </span>
    }
    @if (isFutureBenefit) {
    <span>
      <mwp-text-translate text="Please select the benefit option you wish to replace the terminating benefit selected on the previous page." jsonKey="benefitSelectionFutureBenefit" />
    </span>
    }
  </div>
  <div class="content-container table-comp mb-3">
    <div class="title">
      <mwp-text-translate text="Benefits" jsonKey="benefits" />
    </div>
    <div class="content">
      <mwp-table-formarray [form]="benefitSelectionForm" [arrayName]="benefitSelectionFormArrayName" [tableColumns]="tableColumns" [dataSource]="tableMatData" (emitSlideToggleSelection)="selectedBuyUpOptionalBenefit($event)" />
    </div>
    <div class="footer">
      <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="benefitSelectionForm.invalid" (emitComplete)="complete()"></mwp-benefit-enrollment-wizard-control>
    </div>
  </div>
</div>